import { Trace } from './Trace';

export class Report {
  constructor(private readonly id: number, private readonly name: string, private readonly trace: Trace | null) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getTrace() {
    return this.trace;
  }
}
